const formatNumber = (number) => {
  return number ? Intl.NumberFormat("es-Cl").format(number) : 0;
};

export { formatNumber };
